import React from "react";

const PageNotFound: React.FC = () => {
    return (
        <div>
            <div className="area-404">
                <div className="container">
                    <div className="row">
                        <div className="col-md-10 col-md-offset-1 col-xs-12">
                            <div className="wrap-404 text-center">
                                <div className="img-404">
                                <img src="images/404.png" alt="404 Not Found" />
                                   
                                </div>
                                <div className="info-404">
                                    <h2>This site not published or does not have a domain assigned to it.</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default PageNotFound;
